import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';

type ReturnValue<T> = [() => T, (newValue: T) => void];

function createSingleton<T>(initialValue: T): ReturnValue<T> {
  let updaters: Dispatch<SetStateAction<T>>[] = [];
  let currentValue = initialValue;

  const useSingleton = () => {
    const [value, updaterFunction] = useState(currentValue);

    useEffect(() => {
      updaters.push(updaterFunction);
      return () => {
        updaters = updaters.filter((el) => el !== updaterFunction);
      };
    }, []);

    return value;
  };

  const updateSingleton = (newValue: T) => {
    currentValue = typeof newValue === 'function' ? newValue(currentValue) : newValue;
    updaters.forEach((updater) => updater(currentValue));
  };

  return [useSingleton, updateSingleton];
}

export default createSingleton;
